module.exports = __webpack_public_path__ + "static/media/define_girl_new_1.799bc61c.png";